
export const insertItem = (array, item, index) => {
  let newArray = array.slice();
  newArray.splice(index, 0, item);
  return newArray;
};

export const replaceItem = (array, item, index) => Object.assign([], array, { [index]: item });

export const removeItem = (array, index) => {
  if (!~index) {
    return array;
  }

  let newArray = array.slice();
  newArray.splice(index, 1);
  return newArray;
};

export const removeItemByParam = (array, paramKey, paramValue) => {
  if (!paramKey) return array

  const index = getIndexByParam(array, paramKey, paramValue)
  if (index === undefined) return array

  let newArray = array.slice();
  newArray.splice(index, 1);
  return newArray;
};

export function getIndexByParam(array, paramKey, paramValue) {
  for (let ii = array.length; ii--;) {
    if (array[ii][paramKey] === paramValue) return ii
  }
  return undefined
}
